import {computed} from "vue"

export const staffRecord = (state)=>{
    return computed(()=>{
        return state
    })
  }
  
  